export enum HomeDialogEventName {
  BREAKING_SOUND_ELEGIBLE = "BREAKING_SOUND_ELEGIBLE",
  BREAKING_SOUND_INELEGIBLE = "BREAKING_SOUND_INELEGIBLE",
  SPECIAL_CAMPAIGN_ELEGIBLE_SUBMITION = "ELEGIBLE_SUBMITION",
  SPECIAL_CAMPAIGN_INELEGIBLE_STAGE_CAREER = "INELEGIBLE_STAGE_CAREER",
  SPECIAL_CAMPAIGN_INELEGIBLE_CURRENT_ADVANCE = "INELEGIBLE_CURRENT_ADVANCE",
  SPECIAL_CAMPAIGN_INELEGIBLE_GENRE = "INELEGIBLE_GENRE",
  SPECIAL_CAMPAIGN_INELEGIBLE_CURRENT_DISTRO = "INELEGIBLE_CURRENT_DISTRO",
  SPECIAL_CAMPAIGN_INELEGIBLE_COUNTRY = "INELEGIBLE_COUNTRY",
  SPECIAL_CAMPAIGN_NOT_SELECTED = "NOT_SELECTED",
  SPECIAL_CAMPAIGN_SELECTED = "SELECTED",
}
